import { AxisDomain } from 'recharts/types/util/types';

const DEFAULT_RECHARTS_MAX_DOMAIN = 4;

interface GetLineChartAxisDomainOptions {
  shouldCalculateTickDomain: boolean;
  yMax: number;
}

export const getLineChartAxisDomain = ({
  shouldCalculateTickDomain,
  yMax,
}: GetLineChartAxisDomainOptions): AxisDomain => {
  // Calculate domain relative to min-max data values,
  // to be used for chart data known to have small values (0-1)
  if (shouldCalculateTickDomain) {
    return [
      (min: number) => {
        if (!isFinite(min)) {
          return 0;
        }
        const minAxis = min - Math.abs(min * 0.15);
        return min >= 0 && minAxis <= 1 ? 0 : Math.floor(minAxis);
      },
      (max: number) => {
        if (!isFinite(max)) {
          return 1;
        }
        return max || 1;
      },
    ];
  }

  // Before: 0.22 -> 4, 2 -> 4
  // After: 0.22 -> 0.3, 2 -> 2
  if (yMax < DEFAULT_RECHARTS_MAX_DOMAIN) {
    return [
      (min: number) => {
        if (!isFinite(min)) {
          return 0;
        }
        return min >= 0 ? 0 : Math.floor(min);
      },
      (max: number) => {
        if (!isFinite(max)) {
          return 1;
        }
        return Math.ceil(max * 10) / 10;
      },
    ];
  }

  return [
    (min: number) => {
      if (!isFinite(min)) {
        return 0;
      }
      return min >= 0 ? 0 : Math.floor(min);
    },
    'auto',
  ];
};
